import { useEffect, useState } from "react";
import { MAGAZINE_BASE_URL, MAGAZINE_TAGS_URL } from "../../constants/order";
import { useSite } from "./useSite";

interface PayloadProps {
  postsNbr?: number;
  category?: string | null;
  postsId?: string[];
}

const useFetchWpPosts = (execute: boolean = false, payload: PayloadProps) => {
  const { mySite } = useSite();

  const [data, setData] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);

  const postsNbr = payload?.postsNbr || 3;
  const category = payload?.category || null;
  const postsId = payload?.postsId || null;

  useEffect(() => {
    if (execute) {
      fetchRemoteFeed();
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [execute, category]);

  const fetchLocalFeed = async () => {
    const arr: any[] = [];
    // Local feed are used in development environement
    await fetch(`${process.env.PUBLIC_URL}/wpMock/wpPostsMock.json`)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        data.slice(0, postsNbr).forEach((entry) => {
          arr.push(entry);
        });
        setData(arr);
      })
      .catch((_err) => {
        setError(true);
      });
  };

  const fetchRemoteFeed = async () => {
    try {
      setError(false);
      setLoading(true);

      const urlPosts = new URL(
        mySite?.storeCfg?.userData?.MAGAZINE_BASE_URL
          ? mySite?.storeCfg?.userData?.MAGAZINE_BASE_URL
          : MAGAZINE_BASE_URL
      );

      if (category) {
        const urlTags = new URL(
          mySite?.storeCfg?.userData?.MAGAZINE_TAGS_URL
            ? mySite?.storeCfg?.userData?.MAGAZINE_TAGS_URL
            : MAGAZINE_TAGS_URL
        );
        urlTags.searchParams.append("search", category);

        const rawTagsResp = await fetch(urlTags);
        const tagsResp = await rawTagsResp.json();
        if (tagsResp?.[0]?.id) {
          urlPosts.searchParams.append("tags", tagsResp[0].id);
        }
      }
      if (postsId) {
        // https://magazine.lapeyre.fr/wp-json/wp/v2/posts?include[]=3904&include[]=3883&include[]=3245
        postsId.forEach((element) => {
          urlPosts.searchParams.append("include[]", element);
        });
      }

      urlPosts.searchParams.append("per_page", postsNbr.toString());
      urlPosts.searchParams.append("_embed", "true");

      const postsRawResp = await fetch(urlPosts);
      const postsResp = await postsRawResp.json();
      setData(postsResp);
    } catch (err) {
      console.error("error fetching remote feeds: ", err);
      setError(true);
      fetchLocalFeed();
    }
    setLoading(false);
  };

  return { data, loading, error };
};

export default useFetchWpPosts;
